import { CodeNameType } from 'components/common/types/AssetList.types';
import AsyncSelect from 'lib/AsyncSelect';
import { AsyncSelectLoadDataHandler, SelectHandler } from 'lib/AsyncSelect/AsyncSelect.types';
import { cancelFunctions } from 'utils/cancelFunctions';
import { getBusinessAreas } from 'modules/api/inventory';
import { formatFilterOptionsName } from 'utils/formatters';
import { FilterBusinessAreaProps } from './FilterBusinessArea.types';

const FilterBusinessArea: React.FC<FilterBusinessAreaProps> = ({ changeFilters, businessArea }) => {
  const fetchFilterOptions = async (query: string): Promise<CodeNameType[]> => {
    if (query.length >= 3) {
      try {
        return await getBusinessAreas(cancelFunctions, query);
      } catch (error) {
        return [];
      }
    }
    return [];
  };

  const loadFilterOptions: AsyncSelectLoadDataHandler<CodeNameType> = async (_, query) => {
    return formatFilterOptionsName(await fetchFilterOptions(query));
  };

  const onSelect: SelectHandler<CodeNameType> = (_, value: CodeNameType) => {
    changeFilters({ businessArea: value });
  };

  return (
    <AsyncSelect
      dataTestId="business-area-input"
      name="businessArea"
      loadData={loadFilterOptions}
      onSelect={onSelect}
      placeholder="Select business area"
      selectedValue={businessArea}
    />
  );
};

export default FilterBusinessArea;
